import _classCallCheck from "/Users/jhonsem/Work/FaceAnalysis_Web/node_modules/@babel/runtime-corejs2/helpers/esm/classCallCheck";
import _createClass from "/Users/jhonsem/Work/FaceAnalysis_Web/node_modules/@babel/runtime-corejs2/helpers/esm/createClass";
import _possibleConstructorReturn from "/Users/jhonsem/Work/FaceAnalysis_Web/node_modules/@babel/runtime-corejs2/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/Users/jhonsem/Work/FaceAnalysis_Web/node_modules/@babel/runtime-corejs2/helpers/esm/getPrototypeOf";
import _inherits from "/Users/jhonsem/Work/FaceAnalysis_Web/node_modules/@babel/runtime-corejs2/helpers/esm/inherits";
import * as tslib_1 from "tslib";
import { Component, Vue } from "vue-property-decorator";
import { Getter, Action } from "vuex-class";
import * as types from "@/store/constants/types";

var VipFixButton =
/*#__PURE__*/
function (_Vue) {
  _inherits(VipFixButton, _Vue);

  function VipFixButton() {
    _classCallCheck(this, VipFixButton);

    return _possibleConstructorReturn(this, _getPrototypeOf(VipFixButton).apply(this, arguments));
  }

  _createClass(VipFixButton, [{
    key: "gotoVip",
    value: function gotoVip() {
      console.log('this.vipdata', this.vipRouterData);

      if (this.vipRouterData) {
        this.routerPush(this.vipRouterData);
      }
    }
  }]);

  return VipFixButton;
}(Vue);

tslib_1.__decorate([Action(types.ROUTER_PUSH)], VipFixButton.prototype, "routerPush", void 0);

tslib_1.__decorate([Getter(types.GETTER_VIP_ROUTER_DATA)], VipFixButton.prototype, "vipRouterData", void 0);

VipFixButton = tslib_1.__decorate([Component({
  components: {}
})], VipFixButton);
export default VipFixButton;